import React from 'react';

const PdpSharedShippingBadgeLazyComponent = React.lazy(() =>
    import(/* webpackChunkName: "PdpSharedShippingBadge" */ './PdpSharedShippingBadge')
);

export const PdpSharedShippingBadgeLazy = props => (
    <React.Suspense fallback="">
        <PdpSharedShippingBadgeLazyComponent {...props} />
    </React.Suspense>
);
